import React, {useEffect, useRef} from 'react';
import {Message} from "./Message";
import {MessageProps} from "./types/messages";
import {useChatContext} from "./ChatContext";

export function History(): React.ReactElement {
    const { chat, history } = useChatContext();

    // -------------------------------------------------------------------------------------------------------------
    // Reference: History
    // -------------------------------------------------------------------------------------------------------------
    const historyRef = useRef<HTMLOListElement>(null);

    useEffect(() => {
        historyRef.current?.scrollTo({
            top: historyRef.current.scrollHeight,
            behavior: 'smooth'
        });
    }, [history.state, chat.openState]);

    return (
        <div id="wvcb__history-wrapper">
            <ol id="wvcb__history" ref={historyRef}>
                {history.getMessages().map((msg: MessageProps, index: number) => <Message key={index} {...msg}/>)}
                {chat.isLoading() ? <Message key={-1} sender="bot" text="" type="loading"/> : null}
            </ol>
        </div>
    );
};
